import React from 'react';
import Titulo from '../comum/Titulo';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { showSuccessMsg } from '../../util/messagesUtil';
import { bindActionCreators } from 'redux';
import cadastrarConfiguracaoEncomenda from '../../actions/empresa/cadastrarConfiguracaoEncomenda';
import buscarConfiguracaoEncomenda from '../../actions/empresa/buscarConfiguracaoEncomenda';
import {
    maxValueMonetario,
    renderFieldCheck,
    renderFieldMonetarioLabelEncima,
    renderFieldPercentLabelEncima,
    maxValueMonetarioPercentual,
    required
} from '../../util/inputs';

export class PainelConfiguracaoEncomendas extends React.Component {
    constructor(props) {
        super(props);
        this.salvar = this.salvar.bind(this)
    }

    componentDidMount() {
        if (this.props.empresaSelecionada.id) {
            this.props.buscarConfiguracaoEncomenda(this.props.empresaSelecionada.id)
        }
    }

    montarParametros() {
        return {
            id: this.props.id,
            habilitadoPrecoKg: this.props.habilitadoPrecoKg,
            precoKg: this.props.habilitadoPrecoKg ? this.props.precoKg.replace('R$', '') : null,
            habilitadoPrecoFixoMaisValorKg: this.props.habilitadoPrecoFixoMaisValorKg,
            precoFixo: this.props.habilitadoPrecoFixoMaisValorKg ? this.props.precoFixo.replace('R$', '') : null,
            valorKg: this.props.habilitadoPrecoFixoMaisValorKg ? this.props.valorKg.replace('R$', '') : null,
            habilitadoTaxaSeguro: this.props.habilitadoTaxaSeguro,
            taxaSeguro: this.props.habilitadoTaxaSeguro ? this.props.taxaSeguro.replace('R$', '') : null,
            mensagem: this.props.mensagem
        }
    }

    salvar() {
        this.props.cadastrarConfiguracaoEncomenda(this.props.empresaSelecionada.id, this.montarParametros())
            .then(() => {
                showSuccessMsg('Configuração salva com sucesso');
            })
    }

    render() {
        const { invalid, pristine } = this.props;
        return (
            <div>
                <Titulo texto="Configuração encomendas" urlRetorno="/menu-encomendas" />
                <h4 className="pageTitle" style={{ fontWeight: 'bold', padding: '15px 0px 15px 0px' }}>Configuração do tipo de cobrança:</h4>
                <div>
                    <form>
                        <div className="form-group">
                            <div>
                                <Field
                                    name="habilitadoPrecoKg"
                                    type="checkbox"
                                    component={renderFieldCheck}
                                    label="Habilitar Preço Kg?"
                                    css="form-check-input"
                                />
                            </div>
                            {this.props.habilitadoPrecoKg && (
                                <div style={{ width: '20%' }}>
                                    <Field
                                        name="precoKg"
                                        validate={[maxValueMonetario, required]}
                                        component={renderFieldMonetarioLabelEncima}
                                        label="Preço do Kg:"
                                    />
                                </div>
                            )}
                        </div>
                        <div className="form-group">
                            <div>
                                <Field
                                    name="habilitadoPrecoFixoMaisValorKg"
                                    type="checkbox"
                                    component={renderFieldCheck}
                                    label="Habilitar Preço Fixo + Preço Kg?"
                                    css="form-check-input"
                                />
                            </div>
                            {this.props.habilitadoPrecoFixoMaisValorKg && (
                                <div style={{ width: '20%' }}>
                                    <Field
                                        name="precoFixo"
                                        validate={[maxValueMonetario, required]}
                                        component={renderFieldMonetarioLabelEncima}
                                        label="Preço fixo:"
                                        style={{ width: '300px' }}
                                    />
                                    <Field
                                        name="valorKg"
                                        validate={[maxValueMonetario, required]}
                                        component={renderFieldMonetarioLabelEncima}
                                        label="Preço do Kg:"
                                        style={{ width: '300px' }}
                                    />
                                </div>
                            )}
                        </div>
                        <div className="form-group">
                            <div>
                                <Field
                                    name="habilitadoTaxaSeguro"
                                    type="checkbox"
                                    component={renderFieldCheck}
                                    label="Habilitar Taxa de Seguro?"
                                    css="form-check-input"
                                />
                            </div>
                            {this.props.habilitadoTaxaSeguro && (
                                <div style={{ width: '20%' }}>
                                    <div className="form-row mt-2">
                                        <label>Valor % do Seguro conforme Nota fiscal ou Valor Declarado:</label>
                                    </div>
                                    <Field
                                        name="taxaSeguro"
                                        validate={[maxValueMonetarioPercentual, required]}
                                        component={renderFieldPercentLabelEncima}
                                        label="Taxa do Seguro:"
                                        style={{ width: '300px' }}
                                        maxLength={5}
                                    />
                                    <span>
                                        (O campo se preenchido será adicionado ao valor do pedido, sendo calculado conforme do valor da nota fiscal ou do valor declarado.)
                                    </span>
                                </div>
                            )}
                        </div>
                        <div className="form-group" style={{ width: '100%' }}>
                            <div className="form-row mt-2">
                                <label>Mensagem de via remetente:</label>
                            </div>
                            <div>
                                <Field
                                    id='mensagemEncomenda'
                                    name="mensagem"
                                    component="textarea"
                                    placeholder="Escreva a descrição da encomenda."
                                    style={{ width: '100%', height: '100px', textAlign: 'justify' }}
                                    maxLength={2000}
                                />
                            </div>
                        </div>
                    </form>
                </div>
                <button type="submit"
                    className="btn btn-laranja" onClick={this.salvar} disabled={invalid || pristine}>
                    Salvar
                </button>
            </div>
        )
    }
}

export const mapStateToProps = state => {
    return {
        initialValues: {
            id: state.configuracaoEncomenda.id,
            habilitadoPrecoKg: state.configuracaoEncomenda.habilitadoPrecoKg,
            precoKg: state.configuracaoEncomenda.precoKg,
            habilitadoPrecoFixoMaisValorKg: state.configuracaoEncomenda.habilitadoPrecoFixoMaisValorKg,
            valorKg: state.configuracaoEncomenda.valorKg,
            precoFixo: state.configuracaoEncomenda.precoFixo,
            habilitadoTaxaSeguro: state.configuracaoEncomenda.habilitadoTaxaSeguro,
            taxaSeguro: state.configuracaoEncomenda.taxaSeguro,
            mensagem: state.configuracaoEncomenda.mensagem
        },
        empresaSelecionada: state.empresaSelecionada,
        habilitadoPrecoKg: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'habilitadoPrecoKg'),
        precoKg: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'precoKg'),
        habilitadoPrecoFixoMaisValorKg: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'habilitadoPrecoFixoMaisValorKg'),
        valorKg: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'valorKg'),
        precoFixo: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'precoFixo'),
        habilitadoTaxaSeguro: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'habilitadoTaxaSeguro'),
        taxaSeguro: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'taxaSeguro'),
        mensagem: formValueSelector('formularioCadastroConfiguracaoEncomenda')(state, 'mensagem'),
        id: state.configuracaoEncomenda.id
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        cadastrarConfiguracaoEncomenda,
        buscarConfiguracaoEncomenda
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioCadastroConfiguracaoEncomenda',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true
})(PainelConfiguracaoEncomendas));